<!--
 * @Author       : Archer<ahh666@qq.com>
 * @Date         : 2023-10-11 14:24:27
 * @LastEditors  : Archer<ahh666@qq.com>
 * @LastEditTime : 2023-10-13 16:11:13
 * @FilePath     : \youxi\youxi\src\views\XXHavingYou\LoginDialog.vue
 * @Description  : Description
-->
<template>
  <div class="login-dialog-wrap">
    <div class="login-main">
      <img
        class="login-dialog-close"
        @click="$emit('close')"
        src="./img/dialog-close-3.png"
      />
      <div class="login-main-title">游严选账号</div>
      <div class="login-main-desc">签署合同交易受法律保护</div>
      <div class="login-form-item login-form-item__phone">
        <!-- <el-input
          v-model="loginForm.phone"
          placeholder="请输入手机号"
        ></el-input> -->
        <country-code
          :phone="loginForm.phone"
          @phoneChange="
            val => {
              loginForm.phone = val.trim();
            }
          "
          @codeChange="
            val => {
              loginForm.country_code = val;
            }
          "
        ></country-code>
      </div>
      <div class="login-form-item login-form-item__sms">
        <el-input
          v-model="loginForm.smsCode"
          placeholder="请输入验证码"
        ></el-input>
        <span
          @click="getSmsCode"
          class="send-sms-btn"
          :class="{ 'send-sms-btn__disabled': !canSendSmsCode }"
        >
          {{ canSendSmsCode ? "发送验证码" : countdownTime + "S" }}</span
        >
      </div>
      <div class="login-form-item login-form-item__invitation">
        <el-input
          v-model="loginForm.invitation_code"
          placeholder="请输入邀请码（非必填）"
        ></el-input>
      </div>
      <div
        class="login-main-btn"
        :class="{ 'login-main-btn__disabled': !canClickLogin }"
        @click="login"
      >
        登录/注册
      </div>
      <div class="login-main-tip">
        <el-checkbox v-model="agreeTip"></el-checkbox>我已阅读并同意
        <span @click="goTradeTip">《游严选代售服务协议》</span>
      </div>
    </div>
  </div>
</template>

<script>
import CountryCode from "@/components/countryCode";
import { smsDirectLoginApi } from "./api";
import { apiSmsSend } from "@/request/API";
export default {
  components: { CountryCode },
  data() {
    return {
      agreeTip: false,
      loginForm: {
        phone: "",
        country_code: "86",
        smsCode: "",
        invitation_code: ""
      },
      canSendSmsCode: true,
      countdownTime: 60
    };
  },
  computed: {
    canClickLogin() {
      const obj = { ...this.loginForm };
      delete obj.invitation_code;
      return Object.values(obj).every(item => item && item.length > 0);
    }
  },
  methods: {
    goTradeTip() {
      window.open(
        `${process.env.VUE_APP_WEBSITE}/tradeTip?id=92&parent_id=91`,
        "_blank"
      );
    },
    countdown() {
      setTimeout(() => {
        if (this.countdownTime-- === 1) {
          this.canSendSmsCode = true;
          this.countdownTime = 60
        } else {
          this.countdown();
        }
      }, 1000);
    },
    login() {
      if (!this.canClickLogin) {
        return;
      }
      if (!this.agreeTip) {
        this.$message({
          type: "error",
          center: true,
          message: "请阅读并同意协议"
        });
        return
      }
      smsDirectLoginApi({
        ...this.loginForm,
        share_type: this.urlParams.sce,
        share_user_id: this.urlParams.u_id,
        activity_id: this.urlParams.a_id,
        channel_code: this.urlParams.channel_code
      })
        .then(res => {
          this.countdownTime = 60
          this.token = res.data.token;
          this.refresh_token = res.data.refresh_token;
          let status = true;
          this.$store.commit("set_token", this.token);
          this.$store.commit("set_refresh_token", this.refresh_token);
          this.$store.commit("set_userData", res.data);
          this.$store.commit("set_loginStatus", status);
          this.$store.state.loginStatus = true;
          this.$store.state.userData = res.data;
          setTimeout(() => {
            sby_setuserid(
              this.$store.state.userData.telphone,
              this.$store.state.userData.nickname,
              this.$store.state.userData.avatar == ""
                ? "https://m.pxb7.com/image/public/avatar.jpg"
                : this.$store.state.userData.avatar
            );
            location.reload();
          }, 400);
        })
        .catch(err => {
          this.$message({
            type: "error",
            center: true,
            message: err.msg
          });
        });
    },
    getSmsCode() {
      if (!this.canSendSmsCode) {
        return;
      }
      const { phone, country_code } = this.loginForm;
      if (!phone) {
        this.$message({
          type: "error",
          center: true,
          message: "请输入手机号码以获取验证码"
        });
        return;
      }
      apiSmsSend({
        phone: phone,
        codeType: country_code == "86" ? 1 : 11,
        country_code,
        smsType: 1 // 不校验注册
      })
        .then(res => {
          this.$message({
            type: "success",
            center: true,
            message: "发送成功"
          });
          this.canSendSmsCode = false;
          this.countdown();
        })
        .catch(err => {
          this.$message({
            type: "error",
            center: true,
            message: err.msg
          });
        });
    }
  },
  created() {
    this.urlParams = this.$route.query;
  }
};
</script>

<style lang="less">
.login-dialog-wrap {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 199;
  background: rgba(0, 0, 0, 0.81);
  .login-main {
    width: 423px;
    height: 554px;
    background: url(./img/login-dialog-bg.png);
    background-size: 100% 100%;
    padding: 40px 20px;
    position: relative;
    .login-dialog-close {
      width: 42px;
      height: 42px;
      position: absolute;
      bottom: -50px;
      left: 190px;
    }
    .login-main-title {
      font-size: 33px;
      font-weight: 500;
      color: #333333;
    }
    .login-main-desc {
      font-size: 20px;
      color: #333333;
    }
    .login-main-btn {
      cursor: pointer;
      font-size: 22px;
      color: #fff;
      width: 385px;
      height: 70px;
      line-height: 70px;
      text-align: center;
      background: var(--primary, #FF5A1F);
      border-radius: 3px;
      margin: 40px 0 20px 0;
      &__disabled {
        background: #a7a7a7;
      }
    }
    .login-main-tip {
      margin-left: 30px;
      font-size: 18px;
      color: #666666;
      .el-checkbox {
        margin-right: 4px;
      }
      .el-checkbox__inner {
        width: 18px;
        height: 18px;
        border: 1px solid var(--primary, #FF5A1F);
        border-radius: 50%;
        &::after {
          left: 6px;
          top: 2px;
        }
      }
      .is-checked .el-checkbox__inner {
        background-color: var(--primary, #FF5A1F);
      }
      > span {
        cursor: pointer;
        color: var(--primary, #FF5A1F);
      }
    }
    .login-form-item {
      margin-top: 15px;
      background: #fff;
      width: 385px;
      height: 70px;
      border-radius: 4px;
      position: relative;
      .send-sms-btn {
        position: absolute;
        right: 33px;
        top: 22px;
        cursor: pointer;
        font-size: 18px;
        color: var(--primary, #FF5A1F);
        &__disabled {
          color: #c7c7c7;
        }
      }
      .el-input__inner {
        font-size: 18px;
        height: 70px;
        border-radius: 4px;
      }
      .countryCode {
        height: 70px;
        .el-input__inner {
          font-size: 18px;
          height: 70px;
          background: none;
          width: 100%;
        }
      }
    }
    .login-form-item__sms .el-input__inner {
      padding-right: 140px;
    }
  }
}
</style>
